// Arabic strings for the fieldB area. Keyed by the English source text; {name} placeholders stay as-is.
// Screens: physical audit walk, first scan walk binding (+ walk exception modal), blind counts (+ RFID import, variance threshold).
export default {
  "(+{count} more)": "(+{count} أخرى)",
  "(Counted: {counted}, Book Stock: {book} on a {par} Par base). Audit Exception {ref} has been flagged for Property Manager investigation.": "(المعدود: {counted}، رصيد الدفاتر: {book} على أساس حد مستوى {par}). تم تحديد استثناء الجرد {ref} لتحقيق مدير العقار.",
  "(Overdue)": "(متأخر)",
  "(default)": "(افتراضي)",
  "(no reads)": "(لا قراءات)",
  "(optional)": "(اختياري)",
  "(set for your organisation)": "(محدد لمؤسستك)",
  "Absent": "غائب",
  "Action": "الإجراء",
  "Active Stock Count & Variance Sessions": "جلسات جرد المخزون والفروقات النشطة",
  "Add photo (optional, JPEG, PNG or WebP up to 5 MB)": "إضافة صورة (اختياري، JPEG أو PNG أو WebP حتى 5 ميغابايت)",
  "Add pooled items to a stock point before logging breakage": "أضف أصنافًا مجمّعة إلى نقطة مخزون قبل تسجيل الكسر",
  "Also read, but not held here: {items}. Transfer them first if they belong to this Stock Point.": "تمت قراءتها أيضًا لكنها غير محفوظة هنا: {items}. انقلها أولًا إذا كانت تتبع نقطة المخزون هذه.",
  "Asset Item & Tag": "صنف الأصل والوسم",
  "Asset Lifecycle Status": "حالة دورة حياة الأصل",
  "Asset tag": "وسم الأصل",
  "Assigned Asset Tag": "وسم الأصل المعيّن",
  "Attach Photo Evidence": "إرفاق صورة كدليل",
  "Audit Batch": "دفعة الجرد",
  "Audit Exception {ref} is now under investigation.": "استثناء الجرد {ref} قيد التحقيق الآن.",
  "Audit Now": "جرد الآن",
  "Audit Type": "نوع الجرد",
  "Audit Variance Threshold Exceeded (>{pct}% Tolerance Breach)": "تم تجاوز حد فروقات الجرد (تجاوز التفاوت >{pct}%)",
  "Audit Walk": "جولة الجرد",
  "Audit scan {tag}": "مسح جرد {tag}",
  "Audit scan {tag} in {room}": "مسح جرد {tag} في {room}",
  "BOM: {bom}": "قائمة المكونات: {bom}",
  "Bind Physical Tag": "ربط الوسم الفعلي",
  "Binding Progress": "تقدّم الربط",
  "Binding is never blocked.": "لا يتم منع الربط أبدًا.",
  "Blind Counts & Variance Console": "وحدة العد الأعمى والفروقات",
  "Blind count - {stockPoint} ({count} item)": "عد أعمى - {stockPoint} ({count} صنف)",
  "Blind count - {stockPoint} ({count} items)": "عد أعمى - {stockPoint} ({count} أصناف)",
  "Blind count submitted successfully ({ref}). All counted items are within the {threshold}% tolerance.": "تم إرسال العد الأعمى بنجاح ({ref}). جميع الأصناف المعدودة ضمن التفاوت المسموح {threshold}%.",
  "Book / Counted": "الدفاتر / المعدود",
  "Book Qty": "كمية الدفاتر",
  "Bound": "مربوط",
  "Breakage event {ref} logged and stock decremented by {quantity} units. Total loss: {loss}.": "تم تسجيل حدث الكسر {ref} وخفض المخزون بمقدار {quantity} وحدة. إجمالي الخسارة: {loss}.",
  "Cadence": "الدورية",
  "Cadence Engine": "محرك الجدولة الدورية",
  "Camera preview": "معاينة الكاميرا",
  "Camera scan failed: {reason}. Enter the 6-character short code instead.": "فشل المسح بالكاميرا: {reason}. أدخل الرمز القصير المكوّن من 6 أحرف بدلًا من ذلك.",
  "Camera scanning is not supported on this device. Use a hardware scanner or enter the short code.": "المسح بالكاميرا غير مدعوم على هذا الجهاز. استخدم ماسحًا يدويًا أو أدخل الرمز القصير.",
  "Camera unavailable": "الكاميرا غير متاحة",
  "Camera unavailable ({reason}). Use a handheld scanner or type the code.": "الكاميرا غير متاحة ({reason}). استخدم ماسحًا يدويًا أو اكتب الرمز.",
  "Category: {category} | UoM: {uom}": "الفئة: {category} | وحدة القياس: {uom}",
  "Change": "تغيير",
  "Check the file": "فحص الملف",
  "Choose the Stock Point that was read": "اختر نقطة المخزون التي تمت قراءتها",
  "Choose the reader export file": "اختر ملف التصدير من القارئ",
  "Condition Grade": "درجة الحالة",
  "Condition of {item}": "حالة {item}",
  "Confirm Tag Binding": "تأكيد ربط الوسم",
  "Confirm Write-Off": "تأكيد الشطب",
  "Contractor handover": "تسليم المقاول",
  "Could not read the selected photo": "تعذّرت قراءة الصورة المحددة",
  "Could not read {file}": "تعذّرت قراءة {file}",
  "Count a Stock Point from a handheld RFID reader export": "عدّ نقطة مخزون من ملف تصدير قارئ RFID محمول",
  "Count recorded ({ref}):": "تم تسجيل العد ({ref}):",
  "Count sheet saved for offline use on {date}.": "ورقة العد محفوظة للاستخدام دون اتصال في {date}.",
  "Count with an RFID reader": "العد باستخدام قارئ RFID",
  "Count {ref} - {item}": "العد {ref} - {item}",
  "Counted": "المعدود",
  "Counted Qty": "الكمية المعدودة",
  "Counted at": "وقت العد",
  "Counted by": "عدّه",
  "Custody Handover": "تسليم العهدة",
  "Cycle Count Batch:": "دفعة الجرد الدوري:",
  "Damage photo attached": "صورة الضرر مرفقة",
  "Damage photo of {item}": "صورة ضرر {item}",
  "Different Model Found": "تم العثور على طراز مختلف",
  "Different model": "طراز مختلف",
  "Different model · catalogue review": "طراز مختلف · مراجعة الكتالوج",
  "Different model?": "طراز مختلف؟",
  "Discarded Quantity": "الكمية المستبعدة",
  "Due Date": "تاريخ الاستحقاق",
  "Enter 6-char short code (e.g. {code}) or scan QR code payload.": "أدخل الرمز القصير المكوّن من 6 أحرف (مثل {code}) أو امسح رمز QR.",
  "Enter a whole number of at least 1": "أدخل عددًا صحيحًا لا يقل عن 1",
  "Enter a whole number, zero or more": "أدخل عددًا صحيحًا، صفرًا أو أكثر",
  "Enter the counted quantity for at least one item": "أدخل الكمية المعدودة لصنف واحد على الأقل",
  "Enter the make or model you actually found.": "أدخل الشركة المصنّعة أو الطراز الذي وجدته فعلًا.",
  "Enter verified count": "أدخل العدد المتحقق منه",
  "Every asset in this room already has a tag.": "كل أصل في هذه الغرفة لديه وسم بالفعل.",
  "Exception": "الاستثناء",
  "Exception (>{pct}%)": "استثناء (>{pct}%)",
  "Exception Status": "حالة الاستثناء",
  "Execute Blind Count": "تنفيذ العد الأعمى",
  "Expected Space": "المكان المتوقع",
  "Expected system quantities are hidden from field counter to enforce strict blind count integrity.": "الكميات المتوقعة في النظام مخفية عن العدّاد الميداني لضمان نزاهة العد الأعمى.",
  "Export Sheet": "تصدير الورقة",
  "Extra Item Recorded": "تم تسجيل صنف إضافي",
  "Extra items found here (not registered)": "أصناف إضافية وُجدت هنا (غير مسجلة)",
  "Fair": "مقبولة",
  "First Scan": "المسح الأول",
  "First Scan Walk Active": "جولة المسح الأول نشطة",
  "First Scan Walk Binding": "ربط الوسوم في جولة المسح الأول",
  "Flag for review": "تحديد للمراجعة",
  "Flagged - not moved": "محدد - لم يُنقل",
  "Flagged for Review": "محدد للمراجعة",
  "Found here": "وُجد هنا",
  "Found in Another Room": "وُجد في غرفة أخرى",
  "Found in the wrong room": "وُجد في الغرفة الخطأ",
  "Found it": "تم العثور عليه",
  "Good": "جيدة",
  "Highlights the next expected item. Nothing is recorded until you scan or tick it.": "يبرز الصنف المتوقع التالي. لا يُسجَّل شيء حتى تمسحه أو تؤشر عليه.",
  "Import RFID Reads": "استيراد قراءات RFID",
  "Investigate": "تحقيق",
  "Item Absent": "الصنف غائب",
  "Item Blueprint": "نموذج الصنف",
  "Item Name": "اسم الصنف",
  "Item absent": "الصنف غائب",
  "Item to Count: {item}": "الصنف المراد عدّه: {item}",
  "Item {item}": "الصنف {item}",
  "Kit expected {model}": "المجموعة تتوقع {model}",
  "Launch Walk": "بدء الجولة",
  "Load Room": "تحميل الغرفة",
  "Loading checklist…": "جارٍ تحميل قائمة التحقق…",
  "Loading count sessions...": "جارٍ تحميل جلسات العد...",
  "Loading scheduled audit tasks...": "جارٍ تحميل مهام الجرد المجدولة...",
  "Located in {room}": "موجود في {room}",
  "Location": "الموقع",
  "Log Breakage Event": "تسجيل حدث كسر",
  "Log Point of Event Breakage": "تسجيل الكسر عند وقوعه",
  "Loss exceeds {limit}: an approval task was routed to the Department Head.": "الخسارة تتجاوز {limit}: تم توجيه مهمة موافقة إلى رئيس القسم.",
  "Make found": "الشركة المصنّعة الموجودة",
  "Manage Schedules & Coverage": "إدارة الجداول والتغطية",
  "Manufacturer Serial #": "الرقم التسلسلي للمصنّع",
  "Manufacturer Serial Number": "الرقم التسلسلي للمصنّع",
  "Mark Absent": "تحديد كغائب",
  "Model found": "الطراز الموجود",
  "Move Not Recorded": "لم يُسجَّل النقل",
  "Move here": "نقل إلى هنا",
  "Move here needs a connection; the item stays flagged until then.": "يتطلب النقل إلى هنا اتصالًا؛ يبقى الصنف محددًا حتى ذلك الحين.",
  "Moved Here": "تم النقل إلى هنا",
  "Moved here": "نُقل إلى هنا",
  "My Scheduled Audit Tasks": "مهام الجرد المجدولة الخاصة بي",
  "My Scheduled Audits": "عمليات الجرد المجدولة الخاصة بي",
  "Next expected: {name} ({code}). Find it, then scan or tick it.": "المتوقع التالي: {name} ({code}). ابحث عنه ثم امسحه أو أشّر عليه.",
  "No assets are registered to this space.": "لا توجد أصول مسجلة في هذا المكان.",
  "No blind counts recorded yet.": "لم يُسجَّل أي عد أعمى بعد.",
  "No blind counts recorded yet. Set up a stock point first, then start a blind count.": "لم يُسجَّل أي عد أعمى بعد. أنشئ نقطة مخزون أولًا ثم ابدأ عدًا أعمى.",
  "No floor": "بلا طابق",
  "No open audit batches": "لا توجد دفعات جرد مفتوحة",
  "No overdue audit tasks.": "لا توجد مهام جرد متأخرة.",
  "No pooled items are held at this stock point.": "لا توجد أصناف مجمّعة في نقطة المخزون هذه.",
  "No property is loaded yet": "لم يتم تحميل أي عقار بعد",
  "No room selected.": "لم يتم اختيار غرفة.",
  "No rooms have been stamped with a Room Kit yet. Stamp a kit to a room, then start the walk.": "لم يتم ختم أي غرفة بمجموعة غرفة بعد. اختم مجموعة على غرفة ثم ابدأ الجولة.",
  "No scheduled audit tasks are assigned to you.": "لا توجد مهام جرد مجدولة مسندة إليك.",
  "No stamped rooms.": "لا توجد غرف مختومة.",
  "No stock points yet — set one up in": "لا توجد نقاط مخزون بعد — أنشئ واحدة في",
  "None of the chips belong to an item held at this Stock Point. A storekeeper maps chips to items on the Stock Points screen.": "لا تتبع أي من الشرائح صنفًا محفوظًا في نقطة المخزون هذه. يربط أمين المخزن الشرائح بالأصناف من شاشة نقاط المخزون.",
  "Not recorded": "غير مسجل",
  "Note": "ملاحظة",
  "Nothing has been moved yet.": "لم يتم نقل أي شيء بعد.",
  "Offline": "غير متصل",
  "Offline Mode": "وضع عدم الاتصال",
  "Offline Scans Synced": "تمت مزامنة عمليات المسح دون اتصال",
  "Offline: tag {tag} for {asset} is saved on this device and is bound when you are back online.": "دون اتصال: الوسم {tag} للأصل {asset} محفوظ على هذا الجهاز وسيُربط عند عودة الاتصال.",
  "Onboarding walk console: scan physical room barcodes, inspect template-stamped draft assets, and bind physical QR tags to activate fixed assets.": "وحدة جولة التهيئة: امسح باركود الغرف، وافحص الأصول المسودة المختومة من القالب، واربط وسوم QR الفعلية لتفعيل الأصول الثابتة.",
  "Open a room by scanning its tag, then scan or tick every expected item with its condition. Items found in the wrong room are never moved without your choice.": "افتح غرفة بمسح وسمها، ثم امسح أو أشّر على كل صنف متوقع مع حالته. لا تُنقل الأصناف الموجودة في الغرفة الخطأ إلا باختيارك.",
  "Open a room first: scan its tag or type its code.": "افتح غرفة أولًا: امسح وسمها أو اكتب رمزها.",
  "Open room": "فتح الغرفة",
  "Or pick the room:": "أو اختر الغرفة:",
  "Or select a stamped room from the walk list": "أو اختر غرفة مختومة من قائمة الجولة",
  "Outlet Audit": "جرد المنفذ",
  "Overdue audits are escalated to the schedule's Department Head.": "تُصعَّد عمليات الجرد المتأخرة إلى رئيس القسم المسؤول عن الجدول.",
  "Owner handover": "تسليم المالك",
  "Page {page} - {total} counted lines": "الصفحة {page} - {total} سطر معدود",
  "Par Level": "الحد المستوى",
  "Pending Scan": "بانتظار المسح",
  "Pending Tasks": "المهام المعلقة",
  "Photo": "صورة",
  "Photos must be JPEG, PNG or WebP images": "يجب أن تكون الصور بصيغة JPEG أو PNG أو WebP",
  "Photos must be JPEG, PNG or WebP images.": "يجب أن تكون الصور بصيغة JPEG أو PNG أو WebP.",
  "Photos need a connection, so it was saved without one.": "تحتاج الصور إلى اتصال، لذا تم الحفظ بدون صورة.",
  "Photos need a connection. While offline the item is saved as damaged without a photo.": "تحتاج الصور إلى اتصال. أثناء عدم الاتصال يُحفظ الصنف كتالف بدون صورة.",
  "Physical Audit": "الجرد الفعلي",
  "Physical Audit Verification & Schedules": "التحقق الفعلي من الجرد والجداول",
  "Physical Condition": "الحالة الفعلية",
  "Physically Counted Quantity": "الكمية المعدودة فعليًا",
  "Point camera or scan tag": "وجّه الكاميرا أو امسح الوسم",
  "Pooled Item Name": "اسم الصنف المجمّع",
  "Poor": "سيئة",
  "Progress:": "التقدّم:",
  "RFID count {ref} submitted for {stockPoint}: {lines} item(s) from {chips} chips, {exceptions} over the variance threshold.": "تم إرسال عد RFID {ref} لـ {stockPoint}: {lines} صنف من {chips} شريحة، {exceptions} فوق حد الفروقات.",
  "RFID count {ref} submitted for {stockPoint}: {lines} item(s) from {chips} chips.": "تم إرسال عد RFID {ref} لـ {stockPoint}: {lines} صنف من {chips} شريحة.",
  "Reader export (CSV or text)": "ملف التصدير من القارئ (CSV أو نص)",
  "Reason Code": "رمز السبب",
  "Recent count session in": "جلسة العد الأخيرة في",
  "Record": "تسجيل",
  "Record Model": "تسجيل الطراز",
  "Record {item} as damaged": "تسجيل {item} كتالف",
  "Remove": "إزالة",
  "Review": "مراجعة",
  "Room": "الغرفة",
  "Room Audit": "جرد الغرفة",
  "Room Door Code (QR / Barcode / Room Number)": "رمز باب الغرفة (QR / باركود / رقم الغرفة)",
  "Room Opened": "تم فتح الغرفة",
  "Room Signed Off": "تم اعتماد الغرفة",
  "Room kit": "مجموعة الغرفة",
  "Room sign-off - {room}": "اعتماد الغرفة - {room}",
  "Rooms assigned to you by recurring audit schedules. Launch a walk to verify a room; signing it off completes the task.": "الغرف المسندة إليك وفق جداول الجرد المتكررة. ابدأ جولة للتحقق من غرفة؛ اعتمادها يُكمل المهمة.",
  "Run blind stock counts, flag variances above {threshold}% and log breakage.": "نفّذ عمليات العد الأعمى للمخزون، وحدد الفروقات التي تتجاوز {threshold}%، وسجّل الكسر.",
  "Save": "حفظ",
  "Save as Damaged": "حفظ كتالف",
  "Saved Offline": "تم الحفظ دون اتصال",
  "Scan & Bind": "مسح وربط",
  "Scan Items": "مسح الأصناف",
  "Scan Not Recorded": "لم يُسجَّل المسح",
  "Scan Physical QR Tag (ULID / Short Code)": "امسح وسم QR الفعلي (ULID / الرمز القصير)",
  "Scan Room Code": "مسح رمز الغرفة",
  "Scan a room code or select a stamped room to start the walk.": "امسح رمز غرفة أو اختر غرفة مختومة لبدء الجولة.",
  "Scan an item from elsewhere": "امسح صنفًا من مكان آخر",
  "Scan an item tag, or tick an item on the checklist": "امسح وسم صنف، أو أشّر على صنف في قائمة التحقق",
  "Scan or enter a room code": "امسح رمز الغرفة أو أدخله",
  "Scan or enter the physical tag": "امسح الوسم الفعلي أو أدخله",
  "Scan or select a room first to bind its tags.": "امسح غرفة أو اخترها أولًا لربط وسومها.",
  "Scan or type the item tag or short code": "امسح أو اكتب وسم الصنف أو الرمز القصير",
  "Scan the tag of an item that is here but belongs to another room": "امسح وسم صنف موجود هنا لكنه يتبع غرفة أخرى",
  "Scan with a handheld scanner into the field below, use the camera, or type the short code printed under the tag.": "امسح بالماسح اليدوي في الحقل أدناه، أو استخدم الكاميرا، أو اكتب الرمز القصير المطبوع أسفل الوسم.",
  "Scan with camera": "المسح بالكاميرا",
  "Schedule": "الجدول",
  "Select Start Blind Count to begin.": "اختر بدء العد الأعمى للبدء.",
  "Select Stock Point": "اختر نقطة المخزون",
  "Select an audit batch and a room to load its checklist.": "اختر دفعة جرد وغرفة لتحميل قائمة التحقق الخاصة بها.",
  "Select an audit batch and room to sign off": "اختر دفعة جرد وغرفة للاعتماد",
  "Select an item": "اختر صنفًا",
  "Select the draft asset to bind": "اختر الأصل المسودة لربطه",
  "Serialized Asset Checklist": "قائمة تحقق الأصول المسلسلة",
  "Session Ref": "مرجع الجلسة",
  "Set up a stock point first": "أنشئ نقطة مخزون أولًا",
  "Shift handover": "تسليم المناوبة",
  "Show next expected": "إظهار المتوقع التالي",
  "Showing the checklist saved for offline use on {date}. Results sync when you are back online.": "عرض قائمة التحقق المحفوظة للاستخدام دون اتصال في {date}. تتم مزامنة النتائج عند عودة الاتصال.",
  "Showing the checklist saved for offline use. Results sync when you are back online.": "عرض قائمة التحقق المحفوظة للاستخدام دون اتصال. تتم مزامنة النتائج عند عودة الاتصال.",
  "Sign off with items missing": "الاعتماد مع وجود أصناف مفقودة",
  "Sign off {room}": "اعتماد {room}",
  "Sign-Off Failed": "فشل الاعتماد",
  "Sign-Off Queued": "الاعتماد في قائمة الانتظار",
  "Sign-Off {room}": "اعتماد {room}",
  "Skipped lines: {lines}": "الأسطر المتجاوزة: {lines}",
  "Spot Check": "فحص عشوائي",
  "Stamped Assets Awaiting Tag Binding": "الأصول المختومة بانتظار ربط الوسم",
  "Stamped Kit Active": "المجموعة المختومة نشطة",
  "Stamped Template:": "القالب المختوم:",
  "Stamped from Room Kit": "مختوم من مجموعة الغرفة",
  "Start Blind Count": "بدء العد الأعمى",
  "Start here: scan the room's tag or type its code": "ابدأ هنا: امسح وسم الغرفة أو اكتب رمزها",
  "Status": "الحالة",
  "Stock Point Location": "موقع نقطة المخزون",
  "Stock Point that was read": "نقطة المخزون التي تمت قراءتها",
  "Stock Points & Par Management": "نقاط المخزون وإدارة الحدود",
  "Stop camera": "إيقاف الكاميرا",
  "Store Audit": "جرد المخزن",
  "Submit Counted Quantities": "إرسال الكميات المعدودة",
  "Submit as blind count": "إرسال كعد أعمى",
  "Submitting...": "جارٍ الإرسال...",
  "Sweep the Stock Point with the handheld reader, export the reads as CSV (one EPC per row; antenna and time columns are optional) and choose the file. Each RFID chip is counted once, however often it was read.": "مرّر القارئ المحمول على نقطة المخزون، وصدّر القراءات كملف CSV (رمز EPC واحد في كل سطر؛ أعمدة الهوائي والوقت اختيارية) ثم اختر الملف. تُحتسب كل شريحة RFID مرة واحدة مهما تكررت قراءتها.",
  "Sync Completed With Issues": "اكتملت المزامنة مع وجود مشكلات",
  "Sync status": "حالة المزامنة",
  "Syncing": "جارٍ المزامنة",
  "Tag {tag} bound to {asset}. The asset is now in_service.": "تم ربط الوسم {tag} بالأصل {asset}. الأصل الآن قيد الخدمة.",
  "Tag {tag} is not registered at this property. It was recorded as an Extra item in {room} ({ref}) for a manager to resolve.": "الوسم {tag} غير مسجل في هذا العقار. تم تسجيله كصنف إضافي في {room} ({ref}) ليعالجه المدير.",
  "Tag {tag} queued and will be checked when you are back online (it may belong to another room or be an extra item).": "الوسم {tag} في قائمة الانتظار وسيتم التحقق منه عند عودة الاتصال (قد يتبع غرفة أخرى أو يكون صنفًا إضافيًا).",
  "Tag {tag} to {asset}": "الوسم {tag} إلى {asset}",
  "Tag {tag} to {asset} in {room}": "الوسم {tag} إلى {asset} في {room}",
  "Tag: {tag}": "الوسم: {tag}",
  "Tap NFC tag": "المس وسم NFC",
  "Tap item NFC tag": "المس وسم NFC للصنف",
  "Tap room NFC tag": "المس وسم NFC للغرفة",
  "Tap the Stock Point's NFC tag": "المس وسم NFC لنقطة المخزون",
  "Target Draft Asset": "الأصل المسودة المستهدف",
  "That tag is not on a Stock Point of this property": "هذا الوسم ليس على نقطة مخزون في هذا العقار",
  "The file is larger than 8 MB. Export a smaller batch of reads from the reader.": "حجم الملف أكبر من 8 ميغابايت. صدّر دفعة أصغر من القراءات من القارئ.",
  "The item is a different make or model than the kit lists (record it after binding)": "الصنف من شركة مصنّعة أو طراز مختلف عما تذكره المجموعة (سجّله بعد الربط)",
  "The item is here but is another make or model than the kit lists. The asset records what you found and the line is flagged for catalogue review. Bind its tag as usual.": "الصنف موجود هنا لكنه من شركة مصنّعة أو طراز آخر غير المذكور في المجموعة. يسجّل الأصل ما وجدته ويُحدَّد السطر لمراجعة الكتالوج. اربط وسمه كالمعتاد.",
  "The item is not in the room. It stays unbound and is flagged as missing so it can be followed up; nothing is deleted. If it turns up later, choose “Found it” and bind its tag.": "الصنف ليس في الغرفة. يبقى غير مربوط ويُحدَّد كمفقود لمتابعته؛ لا يُحذف شيء. إذا ظهر لاحقًا، اختر «تم العثور عليه» واربط وسمه.",
  "The whole Stock Point was swept: count items with no reads as 0": "تم مسح نقطة المخزون بالكامل: احتسب الأصناف بلا قراءات كصفر",
  "There are no open audit batches. An audit batch is opened from Audit Schedules (or by an auditor) before a walk can start.": "لا توجد دفعات جرد مفتوحة. تُفتح دفعة الجرد من جداول الجرد (أو بواسطة مدقق) قبل بدء الجولة.",
  "This browser cannot read tags with the camera. Use a handheld scanner or type the code printed under the tag.": "لا يستطيع هذا المتصفح قراءة الوسوم بالكاميرا. استخدم ماسحًا يدويًا أو اكتب الرمز المطبوع أسفل الوسم.",
  "This room has no stamped assets to bind.": "لا توجد في هذه الغرفة أصول مختومة لربطها.",
  "This room has no stamped assets.": "لا توجد أصول مختومة في هذه الغرفة.",
  "Tick as present with the condition shown": "أشّر كموجود بالحالة المعروضة",
  "Tick {item} as present": "أشّر على {item} كموجود",
  "Toggle Sound Feedback": "تبديل التنبيه الصوتي",
  "Toggle sound feedback": "تبديل التنبيه الصوتي",
  "Tolerance: {pct}%": "التفاوت المسموح: {pct}%",
  "Total Write-Off Loss Amount:": "إجمالي مبلغ خسارة الشطب:",
  "Unbound Draft": "مسودة غير مربوطة",
  "Unknown": "غير معروف",
  "Upgrading to {plan} covers them. Binding is never blocked.": "الترقية إلى {plan} تغطيها. لا يتم منع الربط أبدًا.",
  "Use camera": "استخدام الكاميرا",
  "Variance": "الفرق",
  "Variance %": "نسبة الفرق %",
  "Variance rule: >{pct}% of book stock": "قاعدة الفرق: >{pct}% من رصيد الدفاتر",
  "Variance threshold (%)": "حد الفرق (%)",
  "Variance threshold:": "حد الفرق:",
  "Verified (queued)": "مطابق (في الانتظار)",
  "Verified (ticked)": "مطابق (بالتأشير)",
  "Verified Successfully!": "تم التحقق بنجاح!",
  "View": "عرض",
  "Walk": "الجولة",
  "Within Par": "ضمن الحد",
  "You are offline and audits were not prepared for offline use on this device.": "أنت غير متصل ولم يتم تجهيز عمليات الجرد للاستخدام دون اتصال على هذا الجهاز.",
  "You are offline and this room code is not in the rooms prepared for offline use.": "أنت غير متصل ورمز الغرفة هذا ليس ضمن الغرف المجهزة للاستخدام دون اتصال.",
  "You are offline and this room was not prepared for offline use. Use Prepare for offline on the Sync status page before the walk.": "أنت غير متصل ولم يتم تجهيز هذه الغرفة للاستخدام دون اتصال. استخدم «التجهيز للعمل دون اتصال» في صفحة حالة المزامنة قبل الجولة.",
  "You are offline and this space was not prepared for offline use, so its checklist is not available. Scans are queued and checked on reconnection. Use Prepare for offline on the Sync status page before a shift.": "أنت غير متصل ولم يتم تجهيز هذا المكان للاستخدام دون اتصال، لذا قائمة التحقق غير متاحة. تُحفظ عمليات المسح في قائمة الانتظار وتُفحص عند عودة الاتصال. استخدم «التجهيز للعمل دون اتصال» في صفحة حالة المزامنة قبل المناوبة.",
  "You are offline and this stock point was not prepared for offline use. Use Prepare for offline on the Sync status page before counting offline.": "أنت غير متصل ولم يتم تجهيز نقطة المخزون هذه للاستخدام دون اتصال. استخدم «التجهيز للعمل دون اتصال» في صفحة حالة المزامنة قبل العد دون اتصال.",
  "You are offline: the count for {stockPoint} is saved on this device and will be submitted automatically when you are back online.": "أنت غير متصل: العد الخاص بـ {stockPoint} محفوظ على هذا الجهاز وسيُرسل تلقائيًا عند عودة الاتصال.",
  "Your plan covers {limit} tagged assets and {used} are now tagged.": "تغطي خطتك {limit} أصلًا موسومًا، وتم الآن وسم {used}.",
  "another model": "طراز آخر",
  "belongs to {room} but was scanned in": "يتبع {room} لكن تم مسحه في",
  "closed": "مغلق",
  "counts are saved on this device and submitted when you are back online": "تُحفظ عمليات العد على هذا الجهاز وتُرسل عند عودة الاتصال",
  "detected a": "رصدت",
  "distinct chips": "شرائح مختلفة",
  "draft": "مسودة",
  "e.g. {code}": "مثال: {code}",
  "e.g. {code} or {number}": "مثال: {code} أو {number}",
  "fair": "مقبولة",
  "good": "جيدة",
  "in_service": "قيد الخدمة",
  "kit expects {model}": "المجموعة تتوقع {model}",
  "n/a": "غير متاح",
  "not mapped to an item": "غير مرتبطة بصنف",
  "on": "في",
  "pending investigation": "بانتظار التحقيق",
  "poor": "سيئة",
  "reads": "قراءات",
  "resolved": "تمت المعالجة",
  "room": "الغرفة",
  "stock point": "نقطة المخزون",
  "tags you bind are saved on this device and synced when you are back online": "تُحفظ الوسوم التي تربطها على هذا الجهاز وتُزامن عند عودة الاتصال",
  "this stock point": "نقطة المخزون هذه",
  "to start counting.": "لبدء العد.",
  "under investigation": "قيد التحقيق",
  "where it had been flagged missing": "حيث كان محددًا كمفقود",
  "{applied} queued transaction synced, {failed} need your attention on the Sync status page.": "تمت مزامنة {applied} عملية من قائمة الانتظار، و{failed} تحتاج إلى انتباهك في صفحة حالة المزامنة.",
  "{applied} queued transaction synced.": "تمت مزامنة {applied} عملية من قائمة الانتظار.",
  "{applied} queued transactions synced, {failed} need your attention on the Sync status page.": "تمت مزامنة {applied} عمليات من قائمة الانتظار، و{failed} تحتاج إلى انتباهك في صفحة حالة المزامنة.",
  "{applied} queued transactions synced.": "تمت مزامنة {applied} عمليات من قائمة الانتظار.",
  "{asset} found. Bind its tag now.": "تم العثور على {asset}. اربط وسمه الآن.",
  "{asset} marked absent. It stays unbound and is flagged as missing.": "تم تحديد {asset} كغائب. يبقى غير مربوط ويُحدَّد كمفقود.",
  "{asset} stays registered to {room}; a manager reviews the relocation in the exception queue.": "يبقى {asset} مسجلًا في {room}؛ يراجع المدير النقل في قائمة الاستثناءات.",
  "{asset}: actual make/model recorded and flagged for catalogue review.": "{asset}: تم تسجيل الشركة المصنّعة/الطراز الفعلي وتحديده لمراجعة الكتالوج.",
  "{asset}: saved on this device while offline. It is recorded when you are back online.": "{asset}: تم الحفظ على هذا الجهاز أثناء عدم الاتصال. سيُسجَّل عند عودة الاتصال.",
  "{bound} / {total} Tagged Bound": "{bound} / {total} موسوم ومربوط",
  "{count} Overdue Audit Task:": "{count} مهمة جرد متأخرة:",
  "{count} Overdue Audit Tasks:": "{count} مهام جرد متأخرة:",
  "{count} absent": "{count} غائب",
  "{count} binding waiting to sync": "{count} عملية ربط بانتظار المزامنة",
  "{count} bindings waiting to sync": "{count} عمليات ربط بانتظار المزامنة",
  "{count} count waiting to be submitted": "{count} عد بانتظار الإرسال",
  "{count} counts waiting to be submitted": "{count} عمليات عد بانتظار الإرسال",
  "{count} different model": "{count} طراز مختلف",
  "{count} offline action needs your attention: the record changed before it could be synced.": "{count} إجراء دون اتصال يحتاج إلى انتباهك: تغيّر السجل قبل أن تتم مزامنته.",
  "{count} offline actions need your attention: the record changed before it could be synced.": "{count} إجراءات دون اتصال تحتاج إلى انتباهك: تغيّر السجل قبل أن تتم مزامنته.",
  "{count} other action": "{count} إجراء آخر",
  "{count} other actions": "{count} إجراءات أخرى",
  "{count} sign-off": "{count} اعتماد",
  "{file} is larger than 5 MB.": "حجم {file} أكبر من 5 ميغابايت.",
  "{item} variance is {variance} units ({pct}). Exceeds {threshold}% par threshold: Audit Exception #{ref} created ({status}).": "فرق {item} هو {variance} وحدة ({pct}). يتجاوز حد المستوى {threshold}%: تم إنشاء استثناء الجرد #{ref} ({status}).",
  "{location} was due on": "كان موعد {location} في",
  "{mode} - {count} scan queued locally": "{mode} - {count} عملية مسح محفوظة محليًا",
  "{mode} - {count} scans queued locally": "{mode} - {count} عمليات مسح محفوظة محليًا",
  "{pct} variance": "فرق {pct}",
  "{ref} - waiting for a manager in the exception queue": "{ref} - بانتظار المدير في قائمة الاستثناءات",
  "{room} Stamped Assets Awaiting Tag Binding": "الأصول المختومة في {room} بانتظار ربط الوسم",
  "{room} inspection signed off: {verified} verified, {missing} missing, {mislocated} mislocated. Room compliance {pct}%.": "تم اعتماد فحص {room}: {verified} مطابق، {missing} مفقود، {mislocated} في غير موقعه. امتثال الغرفة {pct}%.",
  "{room} is open. Scan or tick each expected item.": "{room} مفتوحة. امسح أو أشّر على كل صنف متوقع.",
  "{room} loaded - {count} draft asset(s) awaiting a tag.": "تم تحميل {room} - {count} أصل مسودة بانتظار وسم.",
  "{room} sign-off will be committed when the connection returns.": "سيتم تثبيت اعتماد {room} عند عودة الاتصال.",
  "{tagged} Tagged Assets, {pooled} Pooled Lines": "{tagged} أصول موسومة، {pooled} أسطر مجمّعة",
  "{tag} belongs to {location}. It has not been moved: choose Move here or Flag for review.": "{tag} يتبع {location}. لم يتم نقله: اختر «نقل إلى هنا» أو «تحديد للمراجعة».",
  "{tag} marked verified in {room} as damaged with a photo.": "تم تحديد {tag} كمطابق في {room} كتالف مع صورة.",
  "{tag} marked verified in {room} as damaged.": "تم تحديد {tag} كمطابق في {room} كتالف.",
  "{tag} marked verified in {room}.": "تم تحديد {tag} كمطابق في {room}.",
  "{tag} now belongs to {to} (moved from {from}).": "{tag} يتبع الآن {to} (نُقل من {from}).",
  "{tag} now belongs to {to}.": "{tag} يتبع الآن {to}.",
  "{tag} verified locally and queued for sync.": "تم التحقق من {tag} محليًا وإضافته إلى قائمة المزامنة.",
  "{verified} of {expected} ({pct}%)": "{verified} من {expected} ({pct}%)",
  "{verified} of {expected} Assets Verified ({pct}%)": "تم التحقق من {verified} من {expected} أصل ({pct}%)",
};
